"use strict";

var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partitionArray = void 0;
var partitionArray = function partitionArray(a, filterFunction) {
  return a.reduce(function (_ref, element) {
    var _ref2 = _slicedToArray(_ref, 2),
      pass = _ref2[0],
      fail = _ref2[1];
    return filterFunction(element) ? [[].concat(_toConsumableArray(pass), [element]), fail] : [pass, [].concat(_toConsumableArray(fail), [element])];
  }, [[], []]);
};
exports.partitionArray = partitionArray;